import { AIActionType, PlanningContext, ActionCandidate, IActionGenerator, IEvaluator, PlanningState, TacticalNode } from "@/core/battle/ai/types/ai.types";
import { Hex, PathInfo, TerrainType } from "@/core/types/battle.types";
import { coordsToId, idToCoords } from "@/core/utils/hex.utils";

/**
 * Generates Wait action
 * Always available as fallback option
 */
export class WaitActionGenerator implements IActionGenerator {
    readonly generatorType = AIActionType.Wait;
    
    /**
     * Generate wait candidate
     * Evaluator determines utility (usually 0 or slightly negative)
     */
    public generate(state: PlanningState, ctx: PlanningContext, evaluator: IEvaluator<string>): ActionCandidate[] {
        const candidates: ActionCandidate[] = [];
        const hexId = coordsToId(state.position)
        
        const utility = 0;
        const staminaAfter = 0;
        
        const evalResult = {utility, components: {"waiting": utility, "total": utility}}
        
        candidates.push({
            action: {
                type: AIActionType.Wait,
                unitId: ctx.unit.unitId,
                targetHexId: hexId,
                utility: evalResult.utility,
            },
            utility: evalResult.utility,
            staminaAfter: state.stamina,
            position: idToCoords(hexId),
            components: {
                ...evalResult.components,
                total: evalResult.utility,
            }
        })
        
        return candidates;
    }
}